import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import Tippy from '@tippyjs/react';
export var StyledTippy = styled(Tippy)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: initial !important;\n\n  .tippy-content {\n    background-color: #fff;\n    border: 1px solid #c1c1c1;\n    box-shadow: 0 20px 20px rgba(0, 0, 0, 0.16);\n    padding: 0;\n    border-radius: 5px;\n  }\n"])));